export { default } from './SplitProgressBar';
